import {
  AccordionSummary,
  AccordionDetails,
  Box,
  Grid,
  Typography,
  Checkbox,
} from '@mui/material';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import FilterListIcon from '@mui/icons-material/FilterList';

import theme from 'src/style-system/theme';
import {
  updateFilterSelection,
  usePersistentFilterSelection,
} from 'store/filter';

import { allFiltersType } from '@utils/types';
import SmallCrossSign from '@public/assets/svg/SmallCrossSign.svg';
import Accordion from '@components/Accordian';

import SpiceLevel from '../SpiceLevel';

import { useStyles } from './useStyles';

interface DesktopFilterProps {
  filterData: allFiltersType[];
  isSubscriptionPage?: boolean;
  isBgColor?: boolean;
  isNoMarginAtTop?: boolean;
}

const DesktopFilter = ({
  filterData,
  isSubscriptionPage,
  isBgColor = false,
  isNoMarginAtTop = false,
}: DesktopFilterProps) => {
  const filterSelect = usePersistentFilterSelection();
  const classes = useStyles();

  const handleChange = (
    filterId: number,
    filterGroupName: string,
    filterLabel: string
  ) => {
    if (filterSelect[filterId]?.isSelected) {
      updateFilterSelection(filterId, false, filterGroupName, filterLabel);
    } else {
      updateFilterSelection(filterId, true, filterGroupName, filterLabel);
    }
  };

  const onClearFilter = (
    filterId: number,
    filterGroupName: string,
    filterLabel: string
  ) => {
    updateFilterSelection(filterId, false, filterGroupName, filterLabel);
  };

  return (
    <>
      <Box
        className={classes.desktopFilterMainContainer}
        sx={{
          top: isNoMarginAtTop
            ? '80px'
            : isSubscriptionPage
            ? '-100px'
            : '-20px',
        }}
      >
        <Box
          className={classes.filterNameWrapper}
          mt={isNoMarginAtTop ? '0px' : '100px'}
        >
          <FilterListIcon
            fontSize="large"
            sx={{ color: 'garamMasala.main', cursor: 'pointer' }}
          />
          <Typography variant="body1" align="center" color="garamMasala.main">
            Filters
          </Typography>
        </Box>

        {/* filter selected data represtation */}
        <Box className={classes.filterSelectList}>
          {filterData?.map((item) =>
            item.filters.map((filter) =>
              filterSelect[filter.id]?.isSelected ? (
                <Box key={filter.id}>
                  <Box className={classes.filterListWrapper}>
                    <Typography variant="body2" color="cinnamon.main">
                      {filter.label}
                    </Typography>
                    <Box sx={{ cursor: 'pointer' }}>
                      <SmallCrossSign
                        onClick={() =>
                          onClearFilter(
                            filter.id,
                            item.filter_group_name,
                            filter.label
                          )
                        }
                      />
                    </Box>
                  </Box>
                </Box>
              ) : null
            )
          )}
        </Box>

        {/* filter */}
        <Box className={classes.filterContentContainer}>
          {filterData?.map((item) => (
            <Accordion
              bgcolor={
                isBgColor
                  ? theme.palette.whitePepper.main
                  : theme.palette.offWhite.main
              }
              key={item.filter_group_id}
              sx={{ border: 0 }}
              marginbottom={20}
            >
              <AccordionSummary
                expandIcon={
                  <ArrowDropDownIcon
                    fontSize="large"
                    sx={{ color: 'garamMasala.main' }}
                  />
                }
                aria-controls="panel1a-content"
              >
                <Typography variant="body2" align="left" color="cinnamon.main">
                  {item.filter_group_label}
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                {item.filters.map((filter) => (
                  <Box
                    key={filter.id}
                    sx={{ display: 'flex', alignItems: 'center' }}
                  >
                    <Checkbox
                      onChange={() =>
                        handleChange(
                          filter.id,
                          item.filter_group_name,
                          filter.label
                        )
                      }
                      checked={filterSelect[filter.id]?.isSelected || false}
                      sx={{
                        color: 'white',
                        '&.Mui-checked': {
                          color: 'white',
                        },
                      }}
                      id={filter.label}
                    />
                    <Box>
                      <label
                        htmlFor={filter.label}
                        style={{ cursor: 'pointer' }}
                      >
                        <Typography
                          variant="body2"
                          align="left"
                          color="cumin.main"
                        >
                          {filter.label}
                        </Typography>
                      </label>
                    </Box>
                  </Box>
                ))}
              </AccordionDetails>
            </Accordion>
          ))}
        </Box>
      </Box>
    </>
  );
};

export default DesktopFilter;
